export function getDefaultersData() {
  return {
    type: "DEFAULTERS_GET_DATA",
  };
}
export function getDefaultersDataSuccess({ data }) {
  return {
    type: "DEFAULTERS_GET_DATA_SUCCESS",
    payload: { data },
  };
}

export function getDefaultersDataFailure(error) {
  return {
    type: "DEFAULTERS_GET_DATA_FAILURE",
    payload: error,
  };
}

export function defaultersResetErrorsData() {
  return {
    type: "DEFAULTERS_RESET_ERRORS_DATA",
  };
}

export function defaultersErrorsData({ errors }) {
  return {
    type: "DEFAULTERS_ERRORS_DATA",
    payload: { errors },
  };
}

export function defaultersUpdateData({ newData }) {
  return {
    type: "DEFAULTERS_UPDATE_DATA",
    payload: { newData },
  };
}

export function verifyDefaulter({ contractNumber }) {
  return {
    type: "VERIFY_DEFAULTER",
    payload: { contractNumber },
  };
}

export function verifyDefaulterSuccess({ isDefaulter }) {
  return {
    type: "VERIFY_DEFAULTER_SUCCESS",
    payload: { isDefaulter },
  };
}

export function verifyDefaulterFailure({ error }) {
  return {
    type: "VERIFY_DEFAULTER_FAILURE",
    payload: { error },
  };
}
